import { render } from "./MenikheimLayout.vue?vue&type=template&id=5aed9fa2"
import script from "./MenikheimLayout.vue?vue&type=script&lang=js"
export * from "./MenikheimLayout.vue?vue&type=script&lang=js"

import "./MenikheimLayout.vue?vue&type=style&index=0&id=5aed9fa2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__